
<template>
  <div v-scroll-animate ref="hero" class="hero">
    <div class="main-container">
<!--      <div class="bg-placeholder"></div>-->
<!--      <div class="info-container">-->
<!--        <img src="../../assets/logo/seu-logo-name.svg" alt="">-->
<!--      </div>-->
<!--      <div>-->
<!--        <div class="slogan heading-3-regular">-->
<!--          {{ field.value.text }}-->
<!--        </div>-->

<!--        <template v-if="isMobile">-->
<!--        <div class="slogan heading-3-regular">-->
<!--          {{ field.value.subtext }}-->
<!--        </div>-->
<!--        </template>-->

<!--        <template v-if="!isMobile">-->
<!--        <div class="slogan heading-3-small">-->
<!--          {{ field.value.subtext }}-->
<!--        </div>-->
<!--        </template>-->

<!--&lt;!&ndash;        <seu-button&ndash;&gt;-->
<!--&lt;!&ndash;          :label="field.value.buttonLabel"&ndash;&gt;-->
<!--&lt;!&ndash;          :button-link="field.value.buttonLink"&ndash;&gt;-->
<!--&lt;!&ndash;          :is-large="true"&ndash;&gt;-->
<!--&lt;!&ndash;          :button-icon-before="field.value.buttonIcon"&ndash;&gt;-->
<!--&lt;!&ndash;        />&ndash;&gt;-->
<!--      </div>-->

    </div>
    <template v-if="!isMobile">
      <img v-if="!videoLoaded" class="background" alt="Background" :src="field.value.desktop_image"/>
      <video class="background" ref="video" @play="onPlay" autoplay loop playsinline preload="auto" muted :src="field.value.desktop_video"/>
    </template>
    <template v-if="isMobile">
      <img v-if="!videoLoaded" class="background" alt="Background" :src="field.value.mobile_image"/>
      <video class="background" ref="video" @play="onPlay" autoplay loop playsinline preload="auto" muted :src="field.value.mobile_video"/>
    </template>
  </div>
</template>

<script>
import SeuButton from "/seu-frontend/components/SeuButton";
import {isMobile} from "/seu-frontend/services/utils";

export default {
  name: 'Hero',
  components: {SeuButton},
  props: {
    field: {
      type: Object
    }
  },

  methods: {
    onPlay() {
      this.$refs.video.style.opacity = '1';
      this.videoLoaded = true
    }
  },

  data: () => {
    return {
      buttonIcon: require('../../assets/static-icons/icon-calendar.svg'),
      videoLoaded: false,
      isMobile: isMobile()
    }
  }

}
</script>

<style lang="scss">
@import "Hero.scss";
</style>
